import React, { useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  if (currentPage === 'privacy') {
    return <PrivacyPolicy onNavigate={setCurrentPage} data-id="element-0" />;
  }
  if (currentPage === 'terms') {
    return <TermsOfService onNavigate={setCurrentPage} data-id="element-1" />;
  }
  return <LandingPage onNavigate={setCurrentPage} data-id="element-2" />;
}